import React from "react";
import Picky from "ikizmet-react-picky";
import PropTypes from "prop-types";
import "ikizmet-react-picky/dist/picky.css"; // Include CSS

const Dropdown = ({
  options, // can be array of objects or strings
  selectedFilters, //for single option selection pass string or object
  haveOnSelectChange,
  onSelectChange,
  enableMax,
  maxSelect,
  avoidSelectIfMaxSelected,
  selectAllText,
  placeholder,
  valueKey,
  labelKey,
  multiple,
  keepOpen,
  includeSelectAll,
  includeFilter,
  filterPlaceholder,
  manySelectedPlaceholder,
  allSelectedPlaceholder,
  height,
  numberDisplayed,
  enableOnly,
  enableOnlyText,
  render
}) => {
  const onChange = (value) => {
    if (haveOnSelectChange) {
      onSelectChange(value);
      return;
    }

    if (
      Array.isArray(value) &&
      (value.length === 0 || (enableMax && avoidSelectIfMaxSelected && value.length > maxSelect))
    ) {
      return;
    }

    onSelectChange(value);
  };

  return (
    <Picky
      selectAllText={selectAllText}
      placeholder={placeholder}
      options={options}
      value={selectedFilters}
      onChange={onChange}
      valueKey={valueKey ? valueKey : "id"}
      labelKey={labelKey ? labelKey : "name"}
      multiple={multiple ?? true}
      keepOpen={keepOpen}
      includeSelectAll={includeSelectAll}
      includeFilter={includeFilter ?? true}
      filterPlaceholder={filterPlaceholder || "Search..."}
      manySelectedPlaceholder={manySelectedPlaceholder || "%s selected"}
      allSelectedPlaceholder={allSelectedPlaceholder || "%s selected"}
      dropdownHeight={height || 500}
      numberDisplayed={numberDisplayed}
      enableOnly={enableOnly}
      enableOnlyText={enableOnlyText}
      className={enableOnly && "withOnly"}
      render={render}
    />
  );
};

Dropdown.propTypes = {
  selectAllText: PropTypes.string,
  options: PropTypes.array,
  placeholder: PropTypes.string,
  enableOnly: PropTypes.bool,
  enableOnlyText: PropTypes.string,
  numberDisplayed: PropTypes.number,
  maxSelect: PropTypes.number,
  includeSelectAll: PropTypes.bool,
  enableMax: PropTypes.bool,
  selectedFilters: PropTypes.any,
  onSelectChange: PropTypes.func,
  haveOnSelectChange: PropTypes.bool,
  height: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  avoidSelectIfMaxSelected: PropTypes.bool,
  valueKey: PropTypes.string,
  labelKey: PropTypes.string,
  filterPlaceholder: PropTypes.string,
  manySelectedPlaceholder: PropTypes.string,
  allSelectedPlaceholder: PropTypes.string,
  includeFilter: PropTypes.bool,
  multiple: PropTypes.bool,
  keepOpen: PropTypes.bool
};

Dropdown.defaultProps = {
  multiple: true,
  keepOpen: true
};

export default Dropdown;
